import React, { ReactElement } from 'react';
import cx from 'classnames';

import { UserGender } from 'types/enums/UserGender';

import { getPhotoPlaceholders } from 'helpers/photoPlaceholders';

import styles from './userAvatar.module.sass';

type PropTypes = {
  url?: string | null;
  className?: string;
  rounded?: boolean;
  size?: string;
  gender?: UserGender;
  blurSize?: string;
  icon?: ReactElement;
};

export const UserAvatar: React.FC<PropTypes> = ({
  url,
  className = '',
  rounded = true,
  size = '100px',
  gender,
  blurSize,
  icon,
}) => {
  const safeUrl = url || getPhotoPlaceholders(gender, 1)[0];

  return (
    <div
      className={cx(styles.wrapper, className, {
        [styles.rootTypeRounded]: rounded,
      })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        backgroundImage: `url(${safeUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        ...(blurSize && { filter: `blur(${blurSize})` }),
      }}
    >
      {Boolean(icon) && <div className={styles.iconWrap}>{icon}</div>}
    </div>
  );
};
